/*
--------------------------------------------------------------------------
  PRESIK KID PLATFORM
  Copyright © 2026 Presik SAS, All rights reserved.
--------------------------------------------------------------------------
*/

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import "./index.css";
import "react-calendar/dist/Calendar.css";

createRoot(document.getElementById("root")).render(<App />);
